import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Toolbar, Badge, IconButton, Button, Hidden } from '@material-ui/core';
import { withRouter } from 'react-router'
import { useSelector } from 'react-redux';
import CartDiscardTimeController from 'helpers/CartDiscardTimeController';
import {
  Restaurant as RestaurantIcon, Person as PersonIcon, ConfirmationNumber as ConfirmationNumberIcon,
  AddShoppingCart, CardGiftcard
} from '@material-ui/icons';
import Link from '@material-ui/core/Link';
import Icon from '@material-ui/core/Icon';

const { RedirectLogoURL, GiftCardsHeading, HeaderExtraText, TicketsHeading, MembershipsHeading, TicketLinkHeading,
  FoodOrderLinkHeading, DonationLinkHeading, ManageMyBookingButtonTitle, ManageMyBookingButtonShow } = window['runConfig'];

const useStyles = makeStyles(theme => ({
  root: {
    '& > *': {
      margin: theme.spacing(0.3)
    },
    float: 'left',
    marginLeft: '20px',
    color: 'white',
    marginTop: '5px'
  },
  flexGrow: {
    flexGrow: 1
  },
  iconSize: {
    fontSize: "2rem"
  },
  desktopView: {
    color: theme.palette.primary.contrastText,
    fontSize: '14px', marginTop: '5px',
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    cursor: 'pointer'
  },
  mobileView: {
    color: theme.palette.primary.contrastText,
    fontSize: '8px', marginTop: '8px',
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    cursor: 'pointer'
  },
  headerExtraTxtHide: {
    display: 'none'
  },
  headerExtraTxtShow: {
    display: 'block'
  },
  disabledlink: {
    pointerEvents: 'none'
  }
}));

const Topbar = props => {
  const { className, onSidebarOpen, ...rest } = props;

  const classes = useStyles();



  const events = useSelector(state => state.reducerShopCart.events);
  const memberships = useSelector(state => state.reducerShopCart.MembershipPackages);
  const GATickets = useSelector(state => state.reducerShopCart.GATickets);
  const managemybkng = useSelector(state => state.reducerShopCart.managemybooking);
  const orderProducts = useSelector(state => state.reducerShopCart.orderProducts);
  const giftcards = useSelector(state => state.reducerGiftCards);
  const donationProducts = useSelector(state => state.reducerShopCart.donationProducts);

  const handleClick = event => {
    if (managemybkng === false) {
      if (orderProducts && orderProducts.length > 0) {
        props.history.push('/revieworderproducts');
      }
      else
        props.history.push('/Checkout');
    }
  };

  const CountGiftCards = () => {
    let totalGFs = 0;
    if (giftcards.giftcards && giftcards.giftcards.length > 0) {
      totalGFs = giftcards.giftcards.filter(x => x.AddedToCart === true && x.CartQty > 0).map(({ CartQty }) => CartQty).reduce((sum, i) => sum + i, 0);
    }

    return totalGFs;
  }


  const eventitemcount = () => {
    if ((events == null || events.length == 0) && (memberships == null || memberships.length == 0) && (GATickets == null || GATickets.length == 0) && (orderProducts == null || orderProducts.length == 0) && (giftcards.giftcards == null || giftcards.giftcards.length == 0) && (donationProducts == null || donationProducts.length == 0))
      return 0;
    else {
      let qty = 0;
      events.forEach(event => {
        event.TourProducts.forEach(product => {
          qty += product.Quantity;
        })
      });

      GATickets.forEach(ticket => {
        qty += ticket.Quantity;
      })

      donationProducts.forEach(product => {
        qty++;
      })

      if (memberships && memberships.length > 0) {
        qty++;
      }

      orderProducts.forEach(p => {
        qty += p.Quantity;
      });

      if (giftcards.giftcards && giftcards.giftcards.length > 0) {
        qty += CountGiftCards();
      }

      return qty;
    }
  }

  return (
    <AppBar style={{ zIndex: 1000 }}>
      <Toolbar >

        <Hidden smDown>
          <Link to="/" className={managemybkng ? classes.disabledlink : ''} onClick={() => { window.location.href = RedirectLogoURL; }}>
            <img
              alt="Logo"
              src={process.env.PUBLIC_URL + "/images/logos/logo.png"}
              className={(managemybkng ? classes.disabledlink : '') + ' ' + "WebsiteLogoSizeOnLargeDevices"}
            />
          </Link>
        </Hidden>

        <Hidden xsDown mdUp>
          <Link to="/" className={managemybkng ? classes.disabledlink : ''} onClick={() => { window.location.href = RedirectLogoURL; }}>
            <img
              alt="Logo"
              src={process.env.PUBLIC_URL + "/images/logos/logo.png"}
              className={(managemybkng ? classes.disabledlink : '') + ' ' + "WebsiteLogoSizeOnLargeDevices"}
            />
          </Link>
        </Hidden>

        <Hidden smUp>
          <Link to="/" className={managemybkng ? classes.disabledlink : ''} onClick={() => { window.location.href = RedirectLogoURL; }}>
            <img
              alt="Logo"
              src={process.env.PUBLIC_URL + "/images/logos/logo.png"}
              className={(managemybkng ? classes.disabledlink : '') + ' ' + "WebsiteLogoSizeOnMobile"}
            />
            <Hidden smUp>
              <p className="headerExtraTxtMobile"> {HeaderExtraText}</p>
            </Hidden>
          </Link>
        </Hidden>

        <Hidden smDown>
          <p className="headerExtraTxtDesktop"> {HeaderExtraText}</p>
        </Hidden>

        <Hidden xsDown mdUp>
          <p className="headerExtraTxtDesktop"> {HeaderExtraText}</p>
        </Hidden>

        {!managemybkng ?
          <CartDiscardTimeController></CartDiscardTimeController>
          : null}

        {managemybkng ? null :
          <div className={classes.root}>

            <Hidden smDown>

              {TicketsHeading && TicketsHeading != "" ?
                <span>
                  <Badge variant="standard">
                    <ConfirmationNumberIcon />
                    <Link className={classes.desktopView}
                      onClick={() => { props.history.push('/products'); }}>
                      {TicketsHeading}
                    </Link>
                  </Badge>
                </span> : ""}

            </Hidden>

            <Hidden xsDown mdUp>

              {TicketsHeading && TicketsHeading != "" ?
                <span>
                  <Badge variant="standard">
                    <ConfirmationNumberIcon />
                    <Link className={classes.desktopView}
                      onClick={() => { props.history.push('/products'); }}>
                      {TicketsHeading}
                    </Link>
                  </Badge>
                </span> : ""}
            </Hidden>

            <Hidden smUp>
              {TicketsHeading && TicketsHeading != "" ?
                <span>
                  <Badge variant="standard">
                    <ConfirmationNumberIcon />
                    <Link className={classes.mobileView}
                      onClick={() => { props.history.push('/products'); }}>
                      {TicketsHeading}
                    </Link>
                  </Badge>
                </span> : ""}
            </Hidden>

            <Hidden smDown>

              {TicketLinkHeading && TicketLinkHeading != "" ?
                <span>
                  <Badge variant="standard">
                    <ConfirmationNumberIcon />
                    <Link className={classes.desktopView}
                      onClick={() => { props.history.push('/gatickets'); }}>
                      {TicketLinkHeading}
                    </Link>
                  </Badge>
                </span>
                : ""}
            </Hidden>

            <Hidden xsDown mdUp>

              {TicketLinkHeading && TicketLinkHeading != "" ?
                <span>
                  <Badge variant="standard">
                    <ConfirmationNumberIcon />
                    <Link className={classes.desktopView}
                      onClick={() => { props.history.push('/gatickets'); }}>
                      {TicketLinkHeading}
                    </Link>
                  </Badge>
                </span>
                : ""}
            </Hidden>

            <Hidden smUp>

              {TicketLinkHeading && TicketLinkHeading != "" ?
                <span>
                  <Badge variant="standard">
                    <ConfirmationNumberIcon />
                    <Link className={classes.mobileView}
                      onClick={() => { props.history.push('/gatickets'); }}>
                      {TicketLinkHeading}
                    </Link>
                  </Badge>
                </span>
                : ""}
            </Hidden>




            <Hidden smDown>


              {MembershipsHeading && MembershipsHeading != "" ?
                <span>
                  <Badge variant="standard">
                    <PersonIcon />
                    <Link
                      className={classes.desktopView}
                      onClick={() => { props.history.push('/memberships'); }}>
                      {MembershipsHeading}
                    </Link>
                  </Badge>
                </span> : ""}

            </Hidden>

            <Hidden xsDown mdUp>
              {MembershipsHeading && MembershipsHeading != "" ?
                <span>
                  <Badge variant="standard">
                    <PersonIcon />
                    <Link
                      className={classes.desktopView}
                      onClick={() => { props.history.push('/memberships'); }}>
                      {MembershipsHeading}
                    </Link>
                  </Badge>
                </span> : ""}
            </Hidden>


            <Hidden smUp>

              {MembershipsHeading && MembershipsHeading != "" ?
                <span>
                  <Badge variant="standard">
                    <PersonIcon />
                    <Link
                      className={classes.mobileView}
                      onClick={() => { props.history.push('/memberships'); }}>
                      {MembershipsHeading}
                    </Link>
                  </Badge>
                </span> : ""}

            </Hidden>

            <Hidden smDown>
              {GiftCardsHeading && GiftCardsHeading != "" ?
                <span>
                  <Badge variant="standard">
                    <CardGiftcard />
                    <Link
                      className={classes.desktopView}
                      onClick={() => { props.history.push('/giftcards'); }}>
                      {GiftCardsHeading}
                    </Link>
                  </Badge>
                </span> : ""}
            </Hidden>

            <Hidden xsDown mdUp>
              {GiftCardsHeading && GiftCardsHeading != "" ?
                <span>
                  <Badge variant="standard">
                    <CardGiftcard />
                    <Link
                      className={classes.desktopView}
                      onClick={() => { props.history.push('/giftcards'); }}>
                      {GiftCardsHeading}
                    </Link>
                  </Badge>
                </span> : ""}
            </Hidden>

            <Hidden smUp>
              {GiftCardsHeading && GiftCardsHeading != "" ?
                <span>
                  <Badge variant="standard">
                    <CardGiftcard />
                    <Link
                      className={classes.mobileView}
                      onClick={() => { props.history.push('/giftcards'); }}>
                      {GiftCardsHeading}
                    </Link>
                  </Badge>
                </span> : ""}
            </Hidden>


            <Hidden smDown>
              {FoodOrderLinkHeading && FoodOrderLinkHeading != "" ?
                <span>
                  <Badge variant="standard">
                    <RestaurantIcon />
                    <Link
                      className={classes.desktopView}
                      onClick={() => { props.history.push('/orderlocation'); }}>
                      {FoodOrderLinkHeading}
                    </Link>
                  </Badge>
                </span> : ""}
            </Hidden>

            <Hidden xsDown mdUp>
              {FoodOrderLinkHeading && FoodOrderLinkHeading != "" ?
                <span>
                  <Badge variant="standard">
                    <RestaurantIcon />
                    <Link
                      className={classes.desktopView}
                      onClick={() => { props.history.push('/orderlocation'); }}>
                      {FoodOrderLinkHeading}
                    </Link>
                  </Badge>
                </span> : ""}
            </Hidden>

            <Hidden smUp>
              {FoodOrderLinkHeading && FoodOrderLinkHeading != "" ?
                <span>
                  <Badge variant="standard">
                    <RestaurantIcon />
                    <Link
                      className={classes.mobileView}
                      onClick={() => { props.history.push('/orderlocation'); }}>
                      {FoodOrderLinkHeading}
                    </Link>
                  </Badge>
                </span> : ""}
            </Hidden>


            <Hidden smDown>
              {DonationLinkHeading && DonationLinkHeading != "" ?
                <span>
                  <Badge variant="standard">
                    <Icon>volunteer_activism</Icon>
                    <Link
                      className={classes.desktopView}
                      onClick={() => { props.history.push('/donationareas'); }}>
                      {DonationLinkHeading}
                    </Link>
                  </Badge>
                </span> : ""}
            </Hidden>

            <Hidden xsDown mdUp>
              {DonationLinkHeading && DonationLinkHeading != "" ?
                <span>
                  <Badge variant="standard">
                    <Icon>volunteer_activism</Icon>
                    <Link
                      className={classes.desktopView}
                      onClick={() => { props.history.push('/donationareas'); }}>
                      {DonationLinkHeading}
                    </Link>
                  </Badge>
                </span> : ""}
            </Hidden>

            <Hidden smUp>
              {DonationLinkHeading && DonationLinkHeading != "" ?
                <span>
                  <Badge variant="standard">
                    <Icon>volunteer_activism</Icon>
                    <Link
                      className={classes.mobileView}
                      onClick={() => { props.history.push('/donationareas'); }}>
                      {DonationLinkHeading}
                    </Link>
                  </Badge>
                </span> : ""}
            </Hidden>

          </div>
        }

        <div className={classes.flexGrow} />

        <>
          {!managemybkng && ManageMyBookingButtonShow ?
            <Button variant="outlined" size="small" className="ManageMyBooking" onClick={() => { props.history.push('/findmybooking'); }}>
              {ManageMyBookingButtonTitle}
            </Button>
            : ""}

          {!managemybkng ?
            <IconButton color="inherit" onClick={handleClick}>
              <Badge badgeContent={eventitemcount()} color="error">
                <AddShoppingCart className={classes.iconSize} />
              </Badge>
            </IconButton>
            : ""}
        </>
      </Toolbar>
    </AppBar >
  );
};

export default withRouter(Topbar);
